import { IDashboardBusinessControlsGetDTO, IDashboardBusinessControlsViewDTO, IDashboardBusinessControlGetStatusDTO } from './../../coreapi-dto/accounting/dashboardBusinessControl';
import { IRequestEventHandler, CoreApiResponse } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { ContentType } from '../../fetchApiDistributor/contentTypes';
import BaseCoreApiRequest from "../baseCoreApiRequest";
import { INewsChatViewDTO } from '../../coreapi-dto/service/newsChat';


class NewsChatRequest extends BaseCoreApiRequest {

    protected _routePrefix: string
    protected _eventHandler: IRequestEventHandler;
    protected readonly _token: string

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl)
        this._routePrefix = 'RedmineNews'
        this._eventHandler = eventHandler
        this._token = token
    }
    getNews(callback?: (e: CoreApiResponse<INewsChatViewDTO[]>) => void) {
        this.get<INewsChatViewDTO[]>(`${this._baseUrl}/${this._routePrefix}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    markNewAsViewed(idGlobal: string, callback?: (e: CoreApiResponse<any>) => void) {
        this.post<any>(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/MarkAsViewed`, null, 
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), 
            (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        this._eventHandler.onGetResponse(e);
                    }
                }
                callback?.(e);
            }
        )
    }
}

export default NewsChatRequest